<template>
  <div id="RegisterForm" class="container">
    <section class="no-padding">
      <div class="columns">
        <div class="column">
          <h1>{{ $t("register.form.contact_number.info") }}</h1>
        </div>
      </div>
      <div class="columns is-desktop is-vcentered is-centered">
        <div class="column is-one-third">
          <b-field>
            <b-input
              maxlength="11"
              v-model="contactNumber"
              custom-class="dtac-font"
              :has-counter="false"
              :disabled="disableOtpBtn"
              :placeholder="$t('register.form.contact_number.placeholder')"
            />
          </b-field>
        </div>
        <div class="column is-2">
          <button
            class="button is-primary dtac-font"
            @click.prevent="requestOtp()"
            :disabled="disableOtpBtn"
          >
            {{ $t("register.form.contact_number.send_otp_btn") }}
          </button>
        </div>
      </div>

      <!-- Expand Section -->
      <div
        v-if="isShowImeiForm"
        class="notification"
        style="background-color: #e0e0e0;"
      >
        <div class="content">
          <h3>{{ $t("register.form.imei_number.title") }}</h3>
          <p>{{ $t("register.form.imei_number.info") }}</p>
          <!-- DAH NO. -->
          <div class="columns is-desktop is-vcentered is-centered">
            <div class="column is-two-fifths">
              <b-field>
                <b-input
                  required
                  maxlength="11"
                  v-model.lazy="dahNumber"
                  custom-class="dtac-font"
                  :has-counter="false"
                  :placeholder="$t('register.form.imei_number.placeholder.dah')"
                />
              </b-field>
            </div>
            <div class="column is-two-fifths">
              <b-field>
                <b-input
                  disabled
                  v-model="dahImei"
                  custom-class="dtac-font"
                  :placeholder="
                    $t('register.form.imei_number.placeholder.imei')
                  "
                />
              </b-field>
            </div>
            <div class="column is-2">
              <b-button
                outlined
                class="full-width dtac-font"
                type="is-primary"
                @click.prevent="performRegisteration()"
                :disabled="disableRegisterBtn"
                >{{ $t("register.form.imei_number.register_btn") }}</b-button
              >
            </div>
          </div>
          <!-- END : DAH NO. -->
        </div>
      </div>
      <!-- END : Expand Section -->
    </section>
  </div>
</template>

<script>
import AlertManager from "@/managers/AlertManager";
import OtpForm from "@/components/forms/OtpForm.vue";
import NumberApiManager from "@/apis/NumberApiManager";
import CustomerApiManager from "@/apis/CustomerApiManager";

export default {
  name: "RegisterForm",
  props: ["restate", "locToken", "conToken", "contact"],
  data() {
    return {
      disableOtpBtn: false,
      disableRegisterBtn: true,
      isShowImeiForm: false,
      locationToken: "",
      contactToken: "",
      contactNumber: null,
      dahNumber: null,
      dahImei: null
    };
  },
  watch: {
    dahNumber: function(val) {
      if (val) {
        if (val.length >= 11) {
          this.mapMsisdnWithImei(val);
        } else if (val.length === 0) {
          this.dahImei = null;
        }
      }
    },
    contact: function(val) {
      this.contactNumber = val;
    },
    locToken: function(val) {
      this.locationToken = val;
    },
    conToken: function(val) {
      this.contactToken = val;
      this.disableOtpBtn = true;
      this.isShowImeiForm = true;
    },
    restate: function(val) {
      if (val) {
        this.disableOtpBtn = false;
        this.disableRegisterBtn = true;
        this.isShowImeiForm = false;
        this.locationToken = "";
        this.contactToken = "";
        this.contactNumber = null;
        this.dahNumber = null;
        this.dahImei = null;
      }
    }
  },
  methods: {
    requestOtp: async function() {
      var msisdnPrefixRegex = /^66\d+?$/;
      var msisdnPrefixResult = msisdnPrefixRegex.test(this.contactNumber);

      var zeroPrefixRegex = /^0\d+?$/;
      var zeroPrefixResult = zeroPrefixRegex.test(this.contactNumber);

      const contact = this.contactNumber;
      if (zeroPrefixResult || msisdnPrefixResult) {
        const loadingComponent = this.$buefy.loading.open({
          container: null
        });
        const otpInfo = await NumberApiManager.requestSendOtp(
          contact,
          "register"
        );
        loadingComponent.close();
        switch (otpInfo.code) {
          case "0":
            if (otpInfo.data.contact_token) {
              this.updateContactToken(otpInfo.data.contact_token);
            } else {
              this.showOtpForm(otpInfo.data);
            }
            break;

          default:
            AlertManager.showErrorSnackbar(otpInfo.message);

            break;
        }
      } else {
        AlertManager.showErrorSnackbar("Please input Contact Number");
      }
    },
    updateContactToken: function(token) {
      this.contactToken = token;
      this.disableOtpBtn = true;
      this.isShowImeiForm = true;
    },
    showOtpForm: function(otpInfo) {
      this.$buefy.modal.open({
        parent: this,
        component: OtpForm,
        props: {
          contactNumber: this.contactNumber,
          otpResponse: otpInfo
        },
        events: {
          update_validOtp: value => {
            this.updateContactToken(value);
          }
        },
        hasModalCard: true
      });
    },
    mapMsisdnWithImei: async function(msisdn) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const imieInfo = await NumberApiManager.requestGetImeiNumber(msisdn);
      loadingComponent.close();

      switch (imieInfo.code) {
        case "0":
          if (imieInfo.data.imei) {
            this.dahImei = imieInfo.data.imei;
            this.disableRegisterBtn = false;
          } else {
            AlertManager.showErrorSnackbar("IMEI not found");
          }
          break;

        default:
          AlertManager.showErrorSnackbar(imieInfo.message);
          break;
      }
    },
    performRegisteration: async function() {
      const registerParams = {
        msisdn: this.dahNumber,
        imei: this.dahImei,
        contact_token: this.contactToken,
        location_token: this.locationToken
      };
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const registerResult = await CustomerApiManager.requestCreateCustomer(
        registerParams
      );
      loadingComponent.close();

      switch (registerResult.code) {
        case "0":
          this.$emit("update_register_complete", registerResult.data);
          break;

        default:
          AlertManager.showErrorSnackbar(registerResult.message);
          break;
      }
    }
  }
};
</script>

<style scoped>
.no-padding {
  padding: 1.5rem 0px;
}
</style>
